let filterBy = true
let selectProduct = true
let category_filter = [];
let initial_click_event = true;
let lastPacSelectionTs = 0;
let defaultFilterStateApplied = false;

function getLocatorAddressValue() {
    var mainValue = ($("#bh-sl-address").val() || "").trim();
    var secondaryValue = ($(".bh-sl-address").first().val() || "").trim();
    return mainValue || secondaryValue;
}

function setLocatorAddressValue(value) {
    var normalized = (value || "").trim();
    $("#bh-sl-address").val(normalized);
    $(".bh-sl-address").val(normalized);
}

$(function(){
    function applyDefaultFilterState() {
        var isMobile = window.matchMedia("(max-width: 788px)").matches;
        var $filterList = $('#scasl-tag-list-container.type');
        var $selectBox = $('.selectBox.type');

        if (!$filterList.length || !$selectBox.length) {
            return false;
        }

        if (isMobile) {
            $filterList.hide();
            $selectBox.removeClass('on');
            filterBy = true;
        } else {
            $filterList.show();
            $selectBox.addClass('on');
            filterBy = false;
        }

        defaultFilterStateApplied = true;
        return true;
    }

     var type_html = '<li> <label> <input type="checkbox" name="tagsvalue" value="Boutique"> Boutique </label> </li><li> <label> <input type="checkbox" name="tagsvalue" value="Bar / Hotel / Restaurant"> Bar / Hotel / Restaurant </label> </li><li> <label> <input type="checkbox" name="tagsvalue" value="Iconic Venues"> Iconic Venues </label> </li>';
    //var product_html = '<li> <label> <input type="checkbox" name="tagsvalue" value="Iconic Collection"> Iconic Collection </label> </li><li> <label> <input type="checkbox" name="tagsvalue" value="Limited Editions"> Limited Editions </label> </li>';
    if($('.scasl-tag-list.type').html() != type_html){
        $('.scasl-tag-list.type').html(type_html);
        //$('.scasl-tag-list.product').html(product_html);
    }
    /** On Click FILTER BY */
    $("#bh-sl-user-location").submit(function(){
        $(".bh-sl-container .bh-sl-loc-list ul").show();
        $(".bh-sl-container .viewmore").show();
        setLocatorAddressValue(getLocatorAddressValue());
    })
    $('.selectBox.type').on('click', () => {
        $('.selectBox.type').toggleClass("on");
        if(filterBy){
            $('#scasl-tag-list-container.type').slideDown();
                        
            filterBy = false
        }else{
            $('#scasl-tag-list-container.type').slideUp();
                        
            filterBy = true
        }
    });

    applyDefaultFilterState();
    var defaultStateRetry = setInterval(function() {
        if (defaultFilterStateApplied || applyDefaultFilterState()) {
            clearInterval(defaultStateRetry);
        }
    }, 150);
    setTimeout(function() {
        clearInterval(defaultStateRetry);
    }, 4000);

    $("#bh-sl-address").on("blur", function(e) {
        var this_val = $(this).val();
        if( this_val != $(".bh-sl-address").val() ){
            $(".bh-sl-address").val(this_val);
        }
    });
    $("#bh-sl-address").on("focusin", function(e) {
        var this_val = $(this).val();
        if( this_val != $(".bh-sl-address").val() ){
            $(".bh-sl-address").val(this_val);
        }
    });
    $("#bh-sl-address").on("focusout", function(e) {
        var this_val = $(this).val();
        if( this_val != $(".bh-sl-address").val() ){
            $(".bh-sl-address").val(this_val);
        }
    });
    $("#bh-sl-address").change(function(e){
        var this_val = $(this).val();
        if( this_val != $(".bh-sl-address").val() ){
            $(".bh-sl-address").val(this_val);
        }
    });
    $(".bh-sl-address").change(function(){
        var this_val = $(this).val();
        if( this_val != $("#bh-sl-address").val() ){
            $("#bh-sl-address").val(this_val);
        }
    });
    $('.scbh-sl-input-content .bh-sl-address').keypress(function(e){
        var this_val = $(this).val();
        if(e.which == 13) {
            setLocatorAddressValue(this_val);
            $("#bh-sl-user-location").submit();
        }
    });

    $("#bh-sl-address, .bh-sl-address").on("keydown", function(e){
        if (e.key === "Enter" || e.which === 13) {
            setLocatorAddressValue($(this).val());
            setTimeout(function(){
                $("#bh-sl-user-location").submit();
            }, 0);
        }
    });

    $(document).on("mousedown touchend click", ".pac-item", function(){
        var now = Date.now();
        if (now - lastPacSelectionTs < 200) {
            return;
        }
        lastPacSelectionTs = now;

        var this_val = $(this).text().replace(/\s+/g, " ").trim();
        setLocatorAddressValue(this_val);
        setTimeout(function(){
            $("#bh-sl-user-location").submit();
        }, 10);
    });
    $(document).on("click",".bh-sl-loc-list-wrap .row label",function(){
        var this_val = $(this).find("input").val();
        $(".bh-sl-container .viewmore").show();
        if($(this).find("input").prop("checked")){
            $(".filter_tags").show();
            $(".bh-sl-container .bh-sl-loc-list ul").show();
            let filter_exist = category_filter.includes(this_val);
            if(!filter_exist){
                category_filter.push(this_val);
            }
            $(".filter_tags p").empty();
            category_filter.forEach(element =>{
                $(".filter_tags p").html($(".filter_tags p").html()+"<span>"+element+"</span>");
            })
            
        }
        else{
            const index = category_filter.indexOf(this_val);
            category_filter.splice(index, 1);

            if(category_filter.length == 0){
                $(".filter_tags p").html("<span>Boutique</span><span>Bar / Hotel / Restaurant</span><span>Iconic Venues</span>");
            }
            else{
                $(".filter_tags p").empty();
                category_filter.forEach(element =>{
                    $(".filter_tags p").html($(".filter_tags p").html()+"<span>"+element+"</span>");
                })
            }
        }
    });
    $(".fullwidth_btn").click(function(e){
        $("#bh-sl-map-container").toggleClass("fullwidth");
        $("body").toggleClass("onfullwidth_map");
        $("html,body").scrollTop($("#bh-sl-map-container").offset().top);
    })
    $(".viewmore").click(function(e){
        $(".bh-sl-container .bh-sl-loc-list ul").addClass("on");
        $(this).hide();
    })

    var tags_mo = new MutationObserver(function(mutationRecords){
        var type_html = '<li> <label> <input type="checkbox" name="tagsvalue" value="Boutique"> Boutique </label> </li><li> <label> <input type="checkbox" name="tagsvalue" value="Bar / Hotel / Restaurant"> Bar / Hotel / Restaurant </label> </li><li> <label> <input type="checkbox" name="tagsvalue" value="Iconic Venues"> Iconic Venues </label> </li>';
        if($('.scasl-tag-list.type').html() != type_html){
            $('.scasl-tag-list.type').html(type_html);
            $(".filter_tags p").html("<span>Boutique</span><span>Bar / Hotel / Restaurant</span><span>Iconic Venues</span>");
        }
    });
    var config = { childList: true};
    tags_mo.observe($('#scasl-tag-list-container').get(0),config);

    $(window).on('resize', function(){
        applyDefaultFilterState();
    });

    var result_mo = new MutationObserver(function(mutationRecords){
        $(".bh-sl-container .bh-sl-loc-list ul").removeClass("on");
        setLocatorAddressValue(getLocatorAddressValue());
        if( !mutationRecords[0].removedNodes.length && !mutationRecords[mutationRecords.length-1].removedNodes.length){
            var number = mutationRecords.length;
        }else {
            var number = mutationRecords.length - 1;
        }
        if($(mutationRecords[mutationRecords.length-1].addedNodes[0])[0].nodeName == "LI"){
            if($(mutationRecords[mutationRecords.length-1].addedNodes[0]).html().includes("noresults")){
                var number = 0;
            }
        }
        
        $(".result_number").text(number);
        if(mutationRecords.length < 4) {
            $(".bh-sl-container .bh-sl-loc-list ul").addClass("on");
        }
    });
    /*
    $("#scasl-app-container .list").bind("DOMSubtreeModified", function() {
        $('#scasl-app-container .list li').each( (item, value) => {
            if($(value).hasClass("list-focus")) {
                var map_query = $(this).find("#scasl-title").text()+"+"+$(this).find("#scasl-address").text()+"+"+$(this).find("#scasl-address2").text()+"+"+$(this).find("#scasl-city").text()+"+"+$(this).find("#scasl-zipcode").text()+"+"+$(this).find("#scasl-country").text();
                $(".see_on_map a").attr("href", "https://www.google.com/maps/search/?api=1&query="+ map_query);
                if($(window).width() <768){
                    $(".see_on_map").show();
                }
                
            }
        })
    });
    */

})